import React from 'react';

const Help: React.FC = () => {
  return (
    <div className="help">
      <h1>Help Center</h1>
      <p>Help page - to be implemented</p>
    </div>
  );
};

export default Help;
